import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import styles from './PageLayout.module.css';

interface PageLayoutProps {
  children: React.ReactNode;
}

const PageLayout: React.FC<PageLayoutProps> = ({ children }) => {
  const navigate = useNavigate();
  const location = useLocation();

  return (
    <div className={styles.pageContainer}>
      <header className={styles.header}>
        <h1 onClick={() => navigate('/')} style={{ cursor: 'pointer' }}>GoonerGuessr</h1>
        <nav className={styles.nav}>
          {location.pathname === '/' && (
            <button 
              className={styles.navButton}
              onClick={() => navigate('/ranks')}
            >
              View Ranks
            </button>
          )}
        </nav>
      </header>
      <main className={styles.content}>
        {children}
      </main>
    </div>
  );
};

export default PageLayout; 